import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { invalidateCostVsBudgetWidgetData, queryClient } from "./index";

export const useReportsAvailableCurrencies = (config = {}) => {
  return useQuery({
    ...config,
    queryKey: ["reports-available-currencies"],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/currencies/report-available-filter`,
        signal,
      });
    },
  });
};

export const invalidateReportsCostVsBudget = async () => {
  await queryClient.invalidateQueries(["reports-available-currencies"]);
  invalidateCostVsBudgetWidgetData();
};
